<div class="sh-form-group" [class.-sh-is-invalid]="isControlInvalid$ | async" [class]="formGroupStyling">
    <sh-form-label
        [helpText]="helpText"
        [required]="isControlRequired$ | async"
        [for]="controlId"
        [label]="label"
        [labelIcons]="labelIcons"
    ></sh-form-label>

    <ng-content></ng-content>

    <div class="sh-input-field-with-action" *ngIf="currentActionItems; else inputField">
        <ng-container *ngTemplateOutlet="inputField"></ng-container>

        <sh-action-item *ngFor="let item of currentActionItems" [item]="item" class="sh-action-group__item"> </sh-action-item>
    </div>

    <ng-template #inputField>
        <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>
    </ng-template>

    <ng-template #complex>
        <sh-form-checkbox-complex-base
            class="sh-form-group__input"
            [formControl]="control"
            [label]="label"
            [id]="controlId"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            [required]="isControlRequired$ | async"
            [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
            [invalid]="isControlInvalid$ | async"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            [title]="control.disabled ? disabledMsg : ''"
            [hideInnerLabel]="hideInnerLabel"
        >
        </sh-form-checkbox-complex-base>
    </ng-template>

    <ng-template #simple>
        <sh-form-checkbox-base
            class="sh-form-group__input"
            [formControl]="control"
            [label]="label"
            [id]="controlId"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            [required]="isControlRequired$ | async"
            [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
            [invalid]="isControlInvalid$ | async"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            [title]="control.disabled ? disabledMsg : ''"
            [hideInnerLabel]="hideInnerLabel"
        >
        </sh-form-checkbox-base>
    </ng-template>

    <p *ngIf="isControlInvalid$ | async" [id]="describeLabelId" class="sh-form-group__feedback">{{ errorMsg }}</p>
</div>
